import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerPointRadiusListItem = (props) => {
    const { visualizerPointRadius, updateVisualizerSettings, maxPointRadius } = props;
    
    const onRadiusChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ pointRadius: value });
    };
    
    return (
        <SliderListItem
            title='Point Radius'
            value={visualizerPointRadius}
            displayMultiplier={100 / maxPointRadius}
            min={0}
            max={100}
            step={1}
            onValueChange={onRadiusChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { pointRadius: visualizerPointRadius } = state.createPreview.present.videoSettings.visualizer;
    const { maxPointRadius } = state.create.maxValues;

    return { 
        visualizerPointRadius,
        maxPointRadius
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerPointRadiusListItem);